import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { UserService } from '../services/user/userService';

let cachedDepartmentId: string | null = null;
let cachedBlockedIds: string[] | null = null;
let fetchPromise: Promise<string[]> | null = null;

async function fetchBlockedIds(departmentId: string): Promise<string[]> {
    if (cachedDepartmentId === departmentId && cachedBlockedIds !== null) {
        return cachedBlockedIds;
    }

    if (fetchPromise) {
        return fetchPromise;
    }

    fetchPromise = (async () => {
        try {
            const service = new UserService();
            const response = await service.getDepartmentBlockedContractStatuses();
            const statusIds = response.getResponseData()?.data?.statusIds ?? [];

            cachedDepartmentId = departmentId;
            cachedBlockedIds = statusIds;
            return statusIds;
        } finally {
            fetchPromise = null;
        }
    })();

    return fetchPromise;
}

const useDepartmentBlockedContractStatuses = (): string[] => {
    const { user } = useSelector((state: RootState) => state.auth);
    const [blockedIds, setBlockedIds] = useState<string[]>([]);

    useEffect(() => {
        if (!user?.department) {
            setBlockedIds([]);
            cachedDepartmentId = null;
            cachedBlockedIds = null;
            return;
        }

        let cancelled = false;

        fetchBlockedIds(user.department)
            .then((ids) => {
                if (!cancelled) {
                    setBlockedIds(ids);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setBlockedIds([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [user?.department]);

    return blockedIds;
};

export default useDepartmentBlockedContractStatuses;
